// axios
import axios from "axios";

// request and response interceptor
import interceptor from "services/baseInterceptor";

// config
import config from "assets/config";
import interceptorPWA from "./baseInterceptorPWA";

export const ax = axios.create({
  baseURL: config.apiURI,
});

export const axPWA = axios.create({
  baseURL: config.apiURI,
});

export const axApp = axios.create({
  baseURL: config.appURI,
});

export const axAppSRCM = axios.create({
  baseURL: config.apiSRCMURI,
});

export const axAppLoc = axios.create({
  baseURL: config.locationAPIURI,
});

export const axAppPreceptor = axios.create({
  baseURL: config.apiSRCMURI,
});

export const axPlacesAutoComplete = axios.create({
  baseURL: config.placesAutoCompleteURI,
});

export const axSRCMStaticData = axios.create({
  baseURL: config.srcmStaticDataURI,
});

export const axNewStaticData = axios.create({
  baseURL: config.srcmStaticNewDataURI,
});

export const axStaticFileData = axios.create({
  baseURL: config.staticFileDataURI,
});

export const axOms = axios.create({
  baseURL: config.apiOmsURI,
});

export const axAllocation = axios.create({
  baseURL: config.baaDormLists,
});

interceptor(ax);
interceptor(axAppSRCM, config.xClientIdSRCM);
interceptor(axOms, "", true);
interceptorPWA(axPWA);
interceptor(axAllocation);
